
export default {
  components: {
  },
  props: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  created() {
  },
  methods: {
  }
};
